<template>
  <modal
    size="md"
    ref="modalComponent"
    :show="show"
    @hidden="$emit('input', false)"
    @submit="onSubmit"
    :title="title"
    submit-button-text="Yes, Delete"
    cancel-button-text="No, I changed my mind"
    submit-btn-variant="danger"
    :is-submitting="isSubmitting"
  >
    <div class="mb-3">
      Are you sure you want to delete initiative{{ isSingular ? '' : 's' }}
      below. This action can not be undone.
    </div>
    <div class="d-flex" v-for="initiative in selectedInitiatives" :key="initiative.id">
      <initiative-icon class="icon" :is-done-and-closed="initiative.isDoneAndClosed" />
      <span>{{ initiative.title }}</span>
    </div>
  </modal>
</template>

<script>
import InitiativeIcon from '@/components/initiative/InitiativeIcon.vue'
import Modal from '@/components/Modal.vue'
import events from '@/constants/events'
import { TOAST_TYPE } from '@/constants/toasts'
import EventBusMixin from '@/mixins/EventBusMixin'
import showToast from '@/utils/showToast'
import { mapActions } from 'vuex'

/**
 * This is a confirmation modal when multiple initiatives are getting deleted at once.
 */
export default {
  name: 'DeleteInitiativesModal',
  props: {
    show: Boolean,
    selectedInitiatives: Array
  },
  model: {
    prop: 'show'
  },
  mixins: [EventBusMixin],
  components: {
    InitiativeIcon,
    Modal
  },
  data() {
    return {
      isSubmitting: false,
      isSingular: this.selectedInitiatives.length === 1
    }
  },
  computed: {
    title() {
      return `Delete Initiative${this.isSingular ? '' : 's'}`
    }
  },
  methods: {
    ...mapActions(['deleteInitiatives']),
    async onSubmit() {
      this.isSubmitting = true
      const selectedInitiatives = this.selectedInitiatives
      try {
        await this.deleteInitiatives({
          orgId: this.selectedInitiatives[0].organizationId,
          initiativeIds: selectedInitiatives.map(i => i.id)
        })
        this.eventBusEmit(events.INITIATIVES_DELETED, selectedInitiatives)
        showToast(`Initiative${this.isSingular ? '' : 's'} deleted successfully`)
      } catch (e) {
        console.log(e)
        showToast(
          'There was a failure while deleting initiatives. Please try again.',
          TOAST_TYPE.ERROR
        )
      }
      this.isSubmitting = false
      this.$refs.modalComponent.hide()
      this.$emit('done', selectedInitiatives)
    }
  }
}
</script>

<style scoped lang="scss">
.icon {
  margin-top: 1px;
}
</style>
